import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { SleepingPlace } from 'sletat-api-services/lib/sletat/models/initial-state/page-models/hotel';
import {
    Facility,
    FacilityGroup,
    Room,
} from '../../../../../models/hotel-room-types';

export interface RoomFacilitiesProps {
    room: Room;
}
interface StyledRoomFacilitiesProps
    extends RoomFacilitiesProps,
        JSSClassesProps<ComponentJSSClasses> {}

export const RoomFacilities = ({
    room,
    classes,
}: StyledRoomFacilitiesProps) => {
    function renderSleepingPlace(sp: SleepingPlace, isLast: boolean) {
        return (
            <span>
                {sp.count === 0 ? '' :  sp.count}&nbsp;{sp.isCustom ? sp.defaultName : sp.name}
                {!isLast && <>&nbsp;и&nbsp;</>}
            </span>
        );
    }

    function renderFacility(facility: Facility, isLast: boolean, key: string) {
        return (
            <span key={key}>
                {facility.name}
                {!isLast && <>,&nbsp;</>}
            </span>
        );
    }

    const {
        bathroomFacilities,
        technicalFacilities,
        bathFacilities,
        balconyFacilities,
        furnitureFacilities,
        specialFacilities,
        viewFacilities,
    } = React.useMemo(() => {
        const bathroomFacilities = Array();
        const technicalFacilities = Array();
        const bathFacilities = Array();
        const balconyFacilities = Array();
        const furnitureFacilities = Array();
        const specialFacilities = Array();
        const viewFacilities = Array();

        room.facilities.forEach((f) => {
            switch (f.groupId) {
                case FacilityGroup.Bathroom:
                    bathroomFacilities.push(f);
                    break;
                case FacilityGroup.Technical:
                    technicalFacilities.push(f);
                    break;
                case FacilityGroup.Bath:
                    bathFacilities.push(f);
                    break;
                case FacilityGroup.Balcony:
                    balconyFacilities.push(f);
                    break;
                case FacilityGroup.Furniture:
                    furnitureFacilities.push(f);
                    break;
                case FacilityGroup.Special:
                    specialFacilities.push(f);
                    break;
                case FacilityGroup.View:
                    viewFacilities.push(f);
                    break;
            }
        });

        return {
            bathroomFacilities,
            technicalFacilities,
            bathFacilities,
            balconyFacilities,
            furnitureFacilities,
            specialFacilities,
            viewFacilities,
        };
    }, [room.facilities]);

    const renderFacilitiesList = (
        title: string,
        facilitiesList: Array<any>,
        facilityKeyName: string
        ) => {
            return (
                <div className={classes.param}>
                    <h4 className={classes.paramName}>{title}</h4>
                    <p className={classes.paramValue}>
                        {facilitiesList.length > 0 ? (
                            <>
                                {facilitiesList.map((f, idx) =>
                                    renderFacility(
                                        f,
                                        idx + 1 === facilitiesList.length,
                                        `${facilityKeyName}-${idx}`
                                    )
                                )}
                            </>
                        ) : (
                            <span className={classes.facilityPlaceholder}>
                                Нет подробной информации
                            </span>
                        )}
                    </p>
                </div>
            );
        };

    return (
        <div className={classes.infoRow}>
            <div className={classes.paramColumn}>
                <div className={classes.param}>
                    <h4 className={classes.paramName}>Спальные места</h4>
                    <p className={classes.paramValue}>
                        {room.sleepingPlaces.length > 0 ? (
                            <>
                                {room.sleepingPlaces.map((sp, idx) =>
                                    <React.Fragment key={`sleeping-places-${idx}`}>
                                        {renderSleepingPlace(
                                            sp,
                                            idx + 1 === room.sleepingPlaces.length
                                        )}
                                    </React.Fragment>
                                )}
                            </>
                        ) : (
                            <span className={classes.facilityPlaceholder}>
                                Нет подробной информации
                            </span>
                        )}
                    </p>
                </div>
                {renderFacilitiesList('Санузел', bathroomFacilities, 'bathroomFacilities')}
                {renderFacilitiesList('Балкон', balconyFacilities, 'balconyFacilities')}
                {renderFacilitiesList('Вид из окна', viewFacilities, 'viewFacilities')}
                {renderFacilitiesList('Мебель', furnitureFacilities, 'furnitureFacilities')}
            </div>

            <div className={classes.paramColumn}>
                {renderFacilitiesList('Техника', technicalFacilities, 'technicalFacilities')}
                {renderFacilitiesList('Ванная', bathFacilities, 'bathFacilities')}
                {renderFacilitiesList('Особенности', specialFacilities, 'specialFacilities')}
            </div>
        </div>
    );
};
